<template>
  <div class="app-container">
    <!-- 搜索筛选区域 -->
    <div class="filter-container">
      <el-form :inline="true" :model="listQuery" class="filter-form">
        <el-form-item label="手机号">
          <el-input
            v-model="listQuery.phone"
            placeholder="请输入手机号"
            clearable
            size="small"
            style="width: 160px"
            @keyup.enter.native="handleFilter"
          />
        </el-form-item>
        <el-form-item label="启用状态">
          <el-select
            v-model="listQuery.is_enabled"
            placeholder="请选择"
            clearable
            size="small"
            style="width: 120px"
          >
            <el-option label="启用" :value="1" />
            <el-option label="禁用" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item label="号码类型">
          <el-select
            v-model="listQuery.phone_type"
            placeholder="请选择"
            clearable
            size="small"
            style="width: 120px"
          >
            <el-option label="真实号码" :value="1" />
            <el-option label="虚拟号码" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="合作商ID">
          <el-input
            v-model="listQuery.app_client_id"
            placeholder="请输入合作商ID"
            clearable
            size="small"
            style="width: 180px"
            type="number"
            @keyup.enter.native="handleFilter"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="handleFilter"
            >查询</el-button
          >
          <el-button size="small" @click="handleReset">重置</el-button>
          <el-button type="primary" size="small" @click="handleCreate"
            >新增</el-button
          >
          <el-button type="success" size="small" @click="handleBatchImport"
            >批量导入</el-button
          >
          <el-button
            type="success"
            size="small"
            :disabled="!selectedIds.length"
            @click="handleBatchEnable"
            >批量启用</el-button
          >
          <el-button
            type="warning"
            size="small"
            :disabled="!selectedIds.length"
            @click="handleBatchDisable"
            >批量禁用</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <el-table
      v-loading="listLoading"
      :data="list"
      border
      stripe
      size="small"
      element-loading-text="Loading"
      empty-text="暂无数据"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="ID" width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="手机号" min-width="130" align="center">
        <template slot-scope="scope">
          {{ scope.row.phone }}
        </template>
      </el-table-column>
      <el-table-column label="合作商" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row?.assignments?.[0]?.app_client?.name || '无' }}
        </template>
      </el-table-column>
      <el-table-column label="合作商id" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row?.assignments?.[0]?.app_client_id || '无' }}
        </template>
      </el-table-column>
      <el-table-column label="号码类型" min-width="130" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.phone_type === 1" type="primary" size="small">
            真实号码
          </el-tag>
          <el-tag
            v-else-if="scope.row.phone_type === 2"
            type="warning"
            size="small"
          >
            虚拟号码
          </el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="启用状态" width="100" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.is_enabled"
            :active-value="1"
            :inactive-value="0"
            @click.native="handleStatusClick(scope.row, $event)"
          />
        </template>
      </el-table-column>
      <el-table-column label="累计使用次数" width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.used_count }}
        </template>
      </el-table-column>
      <el-table-column label="最后使用时间" width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.last_used_at || '无' }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>
      <el-table-column label="更新时间" width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.updated_at }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="230" align="center" fixed="right">
        <template slot-scope="scope">
          <div class="action-buttons">
            <el-button
              type="primary"
              size="small"
              @click="handleDetail(scope.row)"
              >查看详情</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click="handleUpdate(scope.row)"
              >编辑</el-button
            >
            <el-button
              size="small"
              type="danger"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 详情弹窗 -->
    <el-dialog
      title="手机号账号池详情"
      :visible.sync="detailDialogVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <div class="detail-content">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="ID">{{
            detailData.id || '无'
          }}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{
            detailData.phone || '无'
          }}</el-descriptions-item>
          <el-descriptions-item label="启用状态">
            <el-tag
              v-if="detailData.is_enabled === 1"
              type="success"
              size="small"
              >启用</el-tag
            >
            <el-tag v-else type="info" size="small">禁用</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="累计使用次数">{{
            detailData.used_count || 0
          }}</el-descriptions-item>
          <el-descriptions-item label="最后使用时间">{{
            detailData.last_used_at || '无'
          }}</el-descriptions-item>
          <el-descriptions-item label="备注" :span="2">{{
            detailData.remark || '无'
          }}</el-descriptions-item>
          <el-descriptions-item label="创建时间">{{
            detailData.created_at || '无'
          }}</el-descriptions-item>
          <el-descriptions-item label="更新时间">{{
            detailData.updated_at || '无'
          }}</el-descriptions-item>
        </el-descriptions>

        <!-- 合作商信息 -->
        <div class="assignments-section">
          <h4>合作商信息</h4>
          <el-descriptions :column="2" border size="small">
            <el-descriptions-item label="合作商ID">{{
              detailData?.assignments?.[0]?.app_client_id || '无'
            }}</el-descriptions-item>
            <el-descriptions-item label="合作商名称">{{
              detailData?.assignments?.[0]?.app_client?.name || '无'
            }}</el-descriptions-item>
            <el-descriptions-item label="AppId">{{
              detailData?.assignments?.[0]?.app_client?.app_id || '无'
            }}</el-descriptions-item>
            <el-descriptions-item label="号码类型">
              <el-tag
                v-if="detailData?.phone_type === 1"
                type="success"
                size="small"
                >真实</el-tag
              >
              <el-tag
                v-else-if="detailData?.phone_type === 2"
                type="info"
                size="small"
                >虚拟</el-tag
              >
              <el-tag v-else type="info" size="small">无</el-tag>
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogFormVisible"
      width="550px"
      :close-on-click-modal="false"
      @close="handleClose"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="120px"
        size="small"
        class="form-with-gap"
      >
        <el-form-item label="手机号" prop="phone">
          <el-input
            v-model="form.phone"
            placeholder="请输入手机号"
            :disabled="isEdit"
            maxlength="20"
            clearable
          />
        </el-form-item>
        <el-form-item label="合作商" prop="app_client_id">
          <el-select
            v-model="form.app_client_id"
            placeholder="请选择合作商"
            clearable
            filterable
            :disabled="isEdit"
            style="width: 100%"
          >
            <el-option
              v-for="item in appClientList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="号码类型" prop="phone_type">
          <el-radio-group v-model="form.phone_type">
            <el-radio :label="1">真实</el-radio>
            <el-radio :label="2">虚拟</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="form.remark"
            type="textarea"
            :rows="3"
            placeholder="请输入备注"
            maxlength="500"
            clearable
          />
        </el-form-item>
        <el-form-item label="状态" prop="is_enabled">
          <el-radio-group v-model="form.is_enabled">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" :loading="btnLoading" @click="handleSubmit"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!-- 删除确认弹窗 -->
    <el-dialog
      title="删除确认"
      :visible.sync="deleteDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="delete-tip">
        <p>确定删除该手机号账号？</p>
        <p class="warning-text">
          删除后将解除所有合作商分配关系，该手机号无法再次新建。
        </p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false">取消</el-button>
        <el-button type="danger" :loading="deleteLoading" @click="confirmDelete"
          >确认删除</el-button
        >
      </div>
    </el-dialog>

    <!-- 状态切换确认弹窗 -->
    <el-dialog
      :title="statusDialogTitle"
      :visible.sync="statusDialogVisible"
      width="450px"
      :close-on-click-modal="false"
    >
      <div class="status-tip">
        <p v-if="targetStatus === 1">
          确定启用该手机号账号？启用后可被订单随机选取。
        </p>
        <p v-else>确定禁用该手机号账号？禁用后不会被订单随机选取。</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelStatusChange">取消</el-button>
        <el-button
          type="primary"
          :loading="statusLoading"
          @click="confirmStatusChange"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!-- 批量导入弹窗 -->
    <PhoneAccountImport
      :visible.sync="importDialogVisible"
      :app-client-list="appClientList"
      @success="getList"
    />
  </div>
</template>

<script>
import request from '@/utils/request'
import PhoneAccountImport from './PhoneAccountImport'

export default {
  name: 'PhoneAccountPool',
  components: {
    PhoneAccountImport,
  },
  data() {
    return {
      // 列表数据
      list: null,
      total: 0,
      listLoading: true,
      // 查询参数
      listQuery: {
        page: 1,
        limit: 10,
        phone: undefined,
        is_enabled: undefined,
        app_client_id: undefined,
      },
      // 详情弹窗
      detailDialogVisible: false,
      detailData: {},
      // 新增/编辑弹窗
      dialogFormVisible: false,
      dialogTitle: '',
      btnLoading: false,
      isEdit: false,
      form: {
        id: null,
        phone: '',
        app_client_id: undefined,
        phone_type: 2,
        remark: '',
        is_enabled: 1,
      },
      // 删除确认弹窗
      deleteDialogVisible: false,
      deleteLoading: false,
      deleteId: null,
      // 状态切换确认弹窗
      statusDialogVisible: false,
      statusDialogTitle: '',
      statusLoading: false,
      statusId: null,
      targetStatus: null,
      // 合作商列表（用于下拉选择）
      appClientList: [],
      // 批量导入弹窗
      importDialogVisible: false,
      // 批量操作
      selectedIds: [],
      batchLoading: false,
      // 表单校验规则
      rules: {
        phone: [
          { required: true, message: '手机号不能为空', trigger: 'blur' },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '请输入正确的手机号格式',
            trigger: 'blur',
          },
        ],
        app_client_id: [
          { required: true, message: '请选择合作商', trigger: 'change' },
        ],
        phone_type: [
          { required: true, message: '请选择号码类型', trigger: 'change' },
        ],
        remark: [{ max: 500, message: '最大长度为500个字符', trigger: 'blur' }],
        is_enabled: [
          { required: true, message: '请选择状态', trigger: 'change' },
        ],
      },
    }
  },
  created() {
    this.getList()
    this.getAppClientList()
  },
  methods: {
    /**
     * 获取列表数据
     */
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/phone-account-pool/list',
        method: 'get',
        params: this.listQuery,
      })
        .then((response) => {
          console.log(response)

          this.list = response.data.data || []
          this.total = response.data.total || 0
        })
        .catch((error) => {
          console.error('获取列表失败:', error)
          this.$message.error('获取列表失败')
        })
        .finally(() => {
          this.listLoading = false
        })
    },

    /**
     * 搜索查询
     */
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },

    /**
     * 重置筛选条件
     */
    handleReset() {
      this.listQuery = {
        page: 1,
        limit: 10,
        phone: undefined,
        is_enabled: undefined,
        app_client_id: undefined,
      }
      this.getList()
    },

    /**
     * 页大小变化
     */
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.listQuery.page = 1
      this.getList()
    },

    /**
     * 页码变化
     */
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },

    /**
     * 查看详情
     */
    handleDetail(row) {
      console.log(row)

      this.detailData = row
      this.detailDialogVisible = true
    },

    /**
     * 新增
     */
    handleCreate() {
      this.dialogTitle = '新增手机号账号'
      this.isEdit = false
      this.form = {
        id: null,
        phone: '',
        app_client_id: undefined,
        phone_type: 2,
        remark: '',
        is_enabled: 1,
      }
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
      this.dialogFormVisible = true
    },

    /**
     * 编辑
     */
    handleUpdate(row) {
      this.dialogTitle = '编辑手机号账号'
      this.isEdit = true
      this.form = {
        id: row.id,
        phone: row.phone,
        app_client_id: row.assignments?.[0]?.app_client_id,
        phone_type: row.phone_type || 2,
        remark: row.remark || '',
        is_enabled: row.is_enabled,
      }
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
      this.dialogFormVisible = true
    },

    /**
     * 提交保存
     */
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.btnLoading = true

          // 构建请求数据
          const data = { ...this.form }
          // 新增时不传id
          if (!this.form.id) {
            delete data.id
          }

          request({
            url: '/api/backend/phone-account-pool/store',
            method: 'post',
            data: data,
          })
            .then(() => {
              this.$message.success('保存成功')
              this.dialogFormVisible = false
              this.getList()
            })
            .catch((error) => {
              console.error('保存失败:', error)
              this.$message.error('保存失败')
            })
            .finally(() => {
              this.btnLoading = false
            })
        }
      })
    },

    /**
     * 关闭弹窗
     */
    handleClose() {
      this.dialogFormVisible = false
      this.$refs.form && this.$refs.form.resetFields()
    },

    /**
     * 删除操作 - 打开确认弹窗
     */
    handleDelete(row) {
      this.deleteId = row.id
      this.deleteDialogVisible = true
    },

    /**
     * 确认删除
     */
    confirmDelete() {
      if (!this.deleteId) return

      this.deleteLoading = true

      request({
        url: '/api/backend/phone-account-pool/delete',
        method: 'post',
        data: {
          id: this.deleteId,
        },
      })
        .then(() => {
          this.$message.success('删除成功')
          this.deleteDialogVisible = false
          this.getList()
        })
        .catch((error) => {
          console.error('删除失败:', error)
          this.$message.error('删除失败')
        })
        .finally(() => {
          this.deleteLoading = false
        })
    },

    /**
     * 状态切换 - 打开确认弹窗
     */
    handleStatusClick(row, event) {
      // 阻止默认切换
      event.preventDefault()
      event.stopPropagation()
      // 点击后 row.is_enabled 已变为目标状态
      this.targetStatus = row.is_enabled
      this.statusId = row.id
      this.statusDialogTitle = this.targetStatus === 0 ? '禁用确认' : '启用确认'
      this.statusDialogVisible = true
    },

    /**
     * 取消状态切换
     */
    cancelStatusChange() {
      // 由于已阻止默认切换，状态未改变，无需手动恢复
      this.statusDialogVisible = false
    },

    /**
     * 确认状态切换
     */
    confirmStatusChange() {
      if (!this.statusId) return

      this.statusLoading = true

      request({
        url: '/api/backend/phone-account-pool/change-status',
        method: 'post',
        data: {
          id: this.statusId,
          is_enabled: this.targetStatus,
        },
      })
        .then(() => {
          this.$message.success('状态更新成功')
          // 更新列表中的状态
          const row = this.list.find((item) => item.id === this.statusId)
          if (row) {
            row.is_enabled = this.targetStatus
          }
          this.statusDialogVisible = false
        })
        .catch((error) => {
          console.error('状态更新失败:', error)
          this.$message.error('状态更新失败')
        })
        .finally(() => {
          this.statusLoading = false
        })
    },

    /**
     * 获取合作商列表（用于下拉选择）
     */
    getAppClientList() {
      request({
        url: '/api/backend/app-client/list',
        method: 'get',
        params: { limit: 500 },
      })
        .then((response) => {
          this.appClientList = response.data.data || []
        })
        .catch((error) => {
          console.error('获取合作商列表失败:', error)
        })
    },

    /**
     * 批量导入 - 打开弹窗
     */
    handleBatchImport() {
      this.importDialogVisible = true
    },

    /**
     * 处理表格选择变化
     */
    handleSelectionChange(val) {
      this.selectedIds = val.map((item) => item.id)
    },

    /**
     * 批量启用
     */
    handleBatchEnable() {
      if (!this.selectedIds.length) return
      this.$confirm('确定启用选中的手机号账号？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.batchLoading = true
          request({
            url: '/api/backend/phone-account-pool/batch-change-status',
            method: 'post',
            data: { ids: this.selectedIds, is_enabled: 1 },
          })
            .then(() => {
              this.$message.success('批量启用成功')
              this.getList()
              this.selectedIds = []
            })
            .catch(() => {
              this.$message.error('批量启用失败')
            })
            .finally(() => {
              this.batchLoading = false
            })
        })
        .catch(() => {})
    },

    /**
     * 批量禁用
     */
    handleBatchDisable() {
      if (!this.selectedIds.length) return
      this.$confirm('确定禁用选中的手机号账号？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.batchLoading = true
          request({
            url: '/api/backend/phone-account-pool/batch-change-status',
            method: 'post',
            data: { ids: this.selectedIds, is_enabled: 0 },
          })
            .then(() => {
              this.$message.success('批量禁用成功')
              this.getList()
              this.selectedIds = []
            })
            .catch(() => {
              this.$message.error('批量禁用失败')
            })
            .finally(() => {
              this.batchLoading = false
            })
        })
        .catch(() => {})
    },
  },
}
</script>

<style scoped>
.filter-container {
  /* margin-bottom: 20px; */
}
.action-buttons {
  display: inline-block;
}
.action-buttons .el-button {
  margin: 2px 0;
}
.action-buttons .el-button + .el-button {
  margin-left: 5px;
}
.filter-form {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
::v-deep .el-form-item {
  margin-bottom: 0;
}
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
.detail-content {
  max-height: 500px;
  overflow-y: auto;
}
.assignments-section {
  margin-top: 20px;
}
.assignments-section h4 {
  margin-bottom: 10px;
  font-weight: 500;
}
.delete-tip {
  padding: 10px 0;
}
.delete-tip p {
  margin: 5px 0;
  line-height: 1.8;
}
.delete-tip .warning-text {
  color: #e6a23c;
  font-size: 14px;
}
.status-tip {
  padding: 10px 0;
}
.status-tip p {
  margin: 5px 0;
  line-height: 1.8;
  font-size: 14px;
}
.form-with-gap .el-form-item {
  margin-bottom: 18px;
}
</style>
